export default {
    name: 'NatWest Visa Debit',
    template: 'bankCard-natwest',
    details: {
        type: 'Visa Debit',
    },
}
